export default __webpack_public_path__ + "static/inmusic-logo-white-cdc8a63a3025662d430efb5172270967.svg";